import { Box, Typography } from '@mui/material';
import LocInput from "../pages/extra/LocInput";

function FilterHeader({ projects, onProjectChange }) {
  // Styles used to mimic native select with custom design
  const selectStyle = {
    width: '100%',
    height: '44px',
    borderRadius: '12px',
    border: '1px solid #CCCCCC',
    paddingLeft: '12px',
    paddingRight: '40px', // Space for arrow
    fontSize: '16px',
    fontWeight: 500,
    color: '#919191',
    backgroundColor: 'white',
    cursor: 'pointer',
    appearance: 'none', // Remove default arrow
    outline: 'none',
    '&:focus': { borderColor: '#3b82f6' } // blue-500
  };

  const arrowStyle = {
    position: 'absolute',
    right: '16px',
    top: '50%',
    transform: 'translateY(-50%)',
    pointerEvents: 'none',
    display: 'flex'
  };

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: { xs: 'column', md: 'row' },
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      // Changed mt: 4 to mt: 0 AND mb: 4 to mb: 0
      mt: 0, mb: 0, gap: 2, width: '100%'
    }}>
      {/* Right Side: Filters */}
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 2, width: { xs: '100%', md: 'auto' } }}>
        {/* Project Dropdown Group */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Box sx={{ position: 'relative', width: { xs: '100%', md: '305px' } }}>
            <Box className='input' component="select" sx={selectStyle} onChange={(e) => onProjectChange(e.target.value)}>
              <option value={null}>Select project</option>
              {projects.map((project) => (
                <option key={project.id} value={project.id} >
                  {project.project_name}
                </option>
              ))}
            </Box>

            {/* Custom Filled Triangle Arrow */}
            <Box sx={arrowStyle}>
              <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 8L0.669873 0.5L9.33013 0.5L5 8Z" fill="#2F2F2F" />
              </svg>
            </Box>
          </Box>
        </Box>

      </Box>
    </Box>
  );
}
export default FilterHeader;